import AbstractRequestTask from "../AbstractRequestTask";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class NagraDRMTask extends AbstractRequestTask {

  constructor(params) {
    super();
    this._url = params.url;
    this._challenge = params.challenge;
  }

  getMethod() {
    return 'POST';
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    return this._url;
  }

  getParams() {
    return { data: this._challenge };
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    // TODO
    if (data.status != 'OK') {
      return false;
    }
    return true;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default NagraDRMTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/video/NagraDRMTask.js